export type User = {
  userId: number;
  companyName: string;
  email: string;
  password: string;
  role: string;
  createdAt: string;
};
export type ToDo = {
  userId: number;
  id: number;
  title: string;
  completed: boolean;
};
export type Tab = {
  tab_id: number;
  tab_title: string;
};

export type Control = {
  control_title: string;
  tabs: Tab[];
};

export type Feature = {
  dimension_title: string;
  controls: Control[];
};

export type UserResponse = {
  message: string;
  userId: string;
  organizationId: string;
  accessToken: string;
  refreshToken: string;
  projects: number;
  features: Feature[];
  role?: string;
  firstName?: string;
  /** Domain selected at account creation (when returned by login API). */
  domain?: string;
  credentials?: {
    dev?: {
      clientId: string;
      clientSecret?: string;
    };
    prod?: {
      clientId: string;
      clientSecret?: string;
    };
  };
  credentialsNote?: string;
};

export type CreateUserResponse = {
  message: string;
  userId: string;
  organizationId: string;
  environment: string;
  credentials?: {
    dev?: {
      clientId: string;
      clientSecret: string;
    };
    prod?: {
      clientId: string;
      clientSecret: string;
    };
  };
  warning?: string;
};

export type LoginInput = {
  username: string;
  password: string;
};

export type AccountEnvironment = 'DEV' | 'PROD';

export const getAccountEnvironment = (): AccountEnvironment => {
  const selected = (localStorage.getItem('SELECTED_ENV') || 'DEV').trim().toUpperCase();
  return selected === 'PROD' ? 'PROD' : 'DEV';
};

/** POST /auth/create-account request body */
export type CreateUserInput = {
  username: string;
  password: string;
  organizationName: string;
  firstName: string;
  lastName: string;
  environment: AccountEnvironment;
  domain: string;
  organizationId?: string;
  divisionId?: string;
  role?: string;
};

export type CreateAccountPayloadInput = Omit<CreateUserInput, 'environment'> & {
  environment?: AccountEnvironment;
};

export const buildCreateAccountPayload = (input: CreateAccountPayloadInput): CreateUserInput => ({
  username: input.username.trim(),
  password: input.password,
  organizationName: input.organizationName.trim(),
  firstName: input.firstName.trim(),
  lastName: input.lastName.trim(),
  environment: input.environment ?? getAccountEnvironment(),
  domain: input.domain.trim().toLowerCase(),
  ...(input.organizationId ? { organizationId: input.organizationId } : {}),
  ...(input.divisionId ? { divisionId: input.divisionId } : {}),
  ...(input.role ? { role: input.role } : {})
});
